var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-sidebar"},[_c('plugin-search'),_vm._v(" "),_c('category-selector'),_vm._v(" "),_c('nav-items',{staticClass:"tw-hidden lg:tw-block"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }